import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import enTranslation from "./translations/en.json"
import frTranslation from "./translations/fr.json"

i18n
   .use(LanguageDetector)
   .use(initReactI18next)
   .init({
      debug: false,
      fallbackLng: "fr",
      interpolation: {
         escapeValue: false,
      },
      resources: {
         en: {
            translation: enTranslation,
         },
         fr: {
            translation: frTranslation,
         },
      },
   })

export default i18n
